// Styles

// Core
import React from 'react'

// 3rd party
import Alert from '@material-ui/lab/Alert'

import LinkButton from 'components/LinkButton'
import {SUPPORT_EMAIL} from 'constants/appConstants'
import styled from 'styled-components'
import {InfoOutlined} from '@material-ui/icons'

type NoPIDAlertProps = {
  className?: string
}

const NoPIDAlert = ({className}: NoPIDAlertProps) => {
  return (
    <NoPIDAlert.Styled className={className} severity='warning' icon={<InfoOutlined />}>
      ClearProp is currently unavailable as the entered address does not match our records. Review
      and update the address or contact{' '}
      <LinkButton
        className='contact-us-button'
        variant='tertiary'
        href={`mailto:${SUPPORT_EMAIL}`}
        title={SUPPORT_EMAIL}
      />{' '}
      for assistance.
    </NoPIDAlert.Styled>
  )
}

NoPIDAlert.Styled = styled(Alert)`
  width: 100%;
  background: ${({theme}) => theme.colors.citrine.lightest};
  border-radius: 8px;
  margin-bottom: 14px;
  align-items: center;

  .contact-us-button {
    line-height: 20px;
  }

  .portal-MuiAlert-message {
    width: 100%;
    display: inline;
  }

  .portal-MuiAlert-icon {
    color: ${({theme}) => theme.colors.gold.dark};
    svg {
      font-size: 20px;
    }
  }
`
export default NoPIDAlert
